import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';

@Component({
  selector: 'app-generic-modal-unsaved-changes',
  imports: [MatButtonModule, MatDialogModule],
  templateUrl: './generic-modal-unsaved-changes.component.html',
  styleUrls: ['./generic-modal-unsaved-changes.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GenericModalUnsavedChangesComponent {}
